import r, { OPTIONS as D } from "../../managers/braze-instance.js";
import ro from "../../util/browser-detector.js";
import {
  clickElement as Et,
  supportsPassive as Tt,
} from "../../util/dom-utils.js";
import { KeyCodes as Ce } from "../../util/key-codes.js";
import m from "../../managers/subscription-manager.js";
import { isIFrame as At } from "../utils/in-app-message-utils.js";
import { IamStrings as sr } from "../constants.js";
export default class InAppMessage {
  constructor(
    t,
    s,
    i,
    h,
    e,
    E,
    n,
    T,
    o,
    r,
    l,
    u,
    a,
    A,
    I,
    c,
    O,
    L,
    _,
    N,
    R,
    S,
    M,
    D,
    C,
    d,
    U,
    b,
    P,
    p,
    f,
    G,
  ) {
    (this.message = t),
      (this.messageAlignment = s),
      (this.slideFrom = i),
      (this.extras = h),
      (this.triggerId = e),
      (this.clickAction = E),
      (this.uri = n),
      (this.openTarget = T),
      (this.dismissType = o),
      (this.duration = r),
      (this.icon = l),
      (this.imageUrl = u),
      (this.imageStyle = a),
      (this.iconColor = A),
      (this.iconBackgroundColor = I),
      (this.backgroundColor = c),
      (this.textColor = O),
      (this.closeButtonColor = L),
      (this.animateIn = _),
      (this.animateOut = N),
      (this.header = R),
      (this.headerAlignment = S),
      (this.headerTextColor = M),
      (this.frameColor = D),
      (this.buttons = C),
      (this.cropType = d),
      (this.orientation = U),
      (this.htmlId = b),
      (this.css = P),
      (this.messageExtras = p),
      (this.language = f),
      (this.altImageText = G),
      (this.message = t),
      (this.messageAlignment = s || InAppMessage.TextAlignment.CENTER),
      (this.duration = r || 5e3),
      (this.slideFrom = i || InAppMessage.SlideFrom.BOTTOM),
      (this.extras = h || {}),
      (this.triggerId = e),
      (this.clickAction = E || InAppMessage.ClickAction.NONE),
      (this.uri = n),
      (this.openTarget = T || InAppMessage.OpenTarget.NONE),
      (this.dismissType = o || InAppMessage.DismissType.AUTO_DISMISS),
      (this.icon = l),
      (this.imageUrl = u),
      (this.imageStyle = a || InAppMessage.ImageStyle.TOP),
      (this.iconColor = A || InAppMessage.th.ih),
      (this.iconBackgroundColor = I || InAppMessage.th.sh),
      (this.backgroundColor = c || InAppMessage.th.ih),
      (this.textColor = O || InAppMessage.th.hh),
      (this.closeButtonColor = L || InAppMessage.th.eh),
      (this.animateIn = _),
      null == this.animateIn && (this.animateIn = !0),
      (this.animateOut = N),
      null == this.animateOut && (this.animateOut = !0),
      (this.header = R),
      (this.headerAlignment = S || InAppMessage.TextAlignment.CENTER),
      (this.headerTextColor = M || InAppMessage.th.hh),
      (this.frameColor = D || InAppMessage.th.Eh),
      (this.buttons = C || []),
      (this.cropType = d || InAppMessage.CropType.FIT_CENTER),
      (this.orientation = U),
      (this.htmlId = b),
      (this.css = P),
      (this.isControl = !1),
      (this.messageExtras = p),
      (this.language = f),
      (this.altImageText = G),
      (this.nh = !1),
      (this.Gt = !1),
      (this.dd = !1),
      (this.Th = !1),
      (this.qo = null),
      (this.$o = null),
      (this.ti = new m()),
      (this.oh = new m()),
      (this.Io = InAppMessage.TextAlignment.CENTER);
  }
  subscribeToClickedEvent(t) {
    return this.ti.Rt(t);
  }
  subscribeToDismissedEvent(t) {
    return this.oh.Rt(t);
  }
  removeSubscription(t) {
    this.ti.removeSubscription(t), this.oh.removeSubscription(t);
  }
  removeAllSubscriptions() {
    this.ti.removeAllSubscriptions(), this.oh.removeAllSubscriptions();
  }
  closeMessage() {
    this.ll(this.qo);
  }
  zo() {
    return !0;
  }
  od() {
    return this.zo();
  }
  _o() {
    return null != this.htmlId && this.htmlId.length > 4;
  }
  Mo() {
    return this._o() && null != this.css && this.css.length > 0;
  }
  Oo() {
    if (this._o() && this.Mo()) return this.htmlId + "-css";
  }
  Wt() {
    return !this.Gt && ((this.Gt = !0), !0);
  }
  sm() {
    return this.Gt;
  }
  $t(t) {
    return !this.dd && ((this.dd = !0), this.ti.L(), !0);
  }
  Ot() {
    return !this.Th && ((this.Th = !0), this.oh.L(), !0);
  }
  hide(t) {
    if (t && t.parentNode) {
      let s = t.closest(".ab-iam-root");
      if ((null == s && (s = t), this.zo() && null != s.parentNode)) {
        const t = s.parentNode.classList;
        t && t.contains(sr.eS) && t.remove(sr.eS),
          document.body.removeEventListener("touchmove", InAppMessage.rh);
      }
      s.className = s.className.replace(InAppMessage.lh, InAppMessage.uh);
    }
    return this.animateOut || !1;
  }
  ll(t, s) {
    if (null == t) return;
    let i;
    (this.qo = null),
      (i =
        -1 === t.className.indexOf("ab-in-app-message")
          ? t.getElementsByClassName("ab-in-app-message")[0]
          : t);
    let h = !1;
    i && (h = this.hide(i));
    const e = document.body;
    let E;
    null != e && (E = e.scrollTop);
    const n = () => {
      if (t && t.parentNode) {
        let s = t.closest(".ab-iam-root");
        null == s && (s = t), s.parentNode && s.parentNode.removeChild(s);
      }
      const i = this.Oo();
      if (null != i) {
        const t = document.getElementById(i);
        t && t.parentNode && t.parentNode.removeChild(t);
      }
      null != e && "Safari" === ro.browser && (e.scrollTop = E),
        s ? s() : this.Ot();
    };
    h ? setTimeout(n, InAppMessage.hr) : n(), this.$o && this.$o.focus();
  }
  No() {
    return document.createTextNode(this.message || "");
  }
  Jo(t) {
    t.setAttribute("alt", this.altImageText || "");
  }
  static rh(t) {
    if (t.targetTouches && t.targetTouches.length > 1) return;
    const s = t.target;
    (s &&
      s.classList &&
      s.classList.contains("ab-message-text") &&
      s.scrollHeight > s.clientHeight) ||
      (document.querySelector(`.${sr.eS}`) &&
        t.cancelable &&
        t.preventDefault());
  }
  ah(t) {
    const s = t.parentNode;
    this.zo() &&
      null != s &&
      this.orientation !== InAppMessage.Orientation.LANDSCAPE &&
      (null != s.classList && s.classList.add(sr.eS),
      document.body.addEventListener(
        "touchmove",
        InAppMessage.rh,
        !!Tt() && { passive: !1 },
      )),
      (t.className += " " + InAppMessage.lh);
  }
  static Ah(t) {
    if (
      t.keyCode === Ce.Ih &&
      !r.re(D.Oh) &&
      document.querySelectorAll(".ab-modal-interactions").length > 0
    ) {
      const t = document.getElementsByClassName("ab-html-message");
      let s = !1;
      for (const i of t) {
        let t = null;
        At(i) &&
          i.contentWindow &&
          (t = i.contentWindow.document.getElementsByClassName(
            "ab-programmatic-close-button",
          )[0]),
          null != t && (Et(t), (s = !0));
      }
      if (!s) {
        const t = document.querySelectorAll(
          ".ab-modal-interactions > .ab-close-button",
        )[0];
        null != t && Et(t);
      }
    }
  }
  Lh() {
    this.nh ||
      r.re(D.Oh) ||
      (document.addEventListener("keydown", InAppMessage.Ah, !1),
      r.mh(() => {
        document.removeEventListener("keydown", InAppMessage.Ah);
      }),
      (this.nh = !0));
  }
  gt(t) {
    const s = {};
    return t
      ? ((s[InAppMessage.ss.pa] = this.message),
        (s[InAppMessage.ss.ma] = this.messageAlignment),
        (s[InAppMessage.ss._h] = this.slideFrom),
        (s[InAppMessage.ss.xs] = this.extras),
        (s[InAppMessage.ss.ua] = this.triggerId),
        (s[InAppMessage.ss.ca] = this.clickAction),
        (s[InAppMessage.ss.URI] = this.uri),
        (s[InAppMessage.ss.fa] = this.openTarget),
        (s[InAppMessage.ss.da] = this.dismissType),
        (s[InAppMessage.ss.la] = this.duration),
        (s[InAppMessage.ss.ga] = this.icon),
        (s[InAppMessage.ss.ns] = this.imageUrl),
        (s[InAppMessage.ss.ja] = this.imageStyle),
        (s[InAppMessage.ss.xa] = this.iconColor),
        (s[InAppMessage.ss.za] = this.iconBackgroundColor),
        (s[InAppMessage.ss.ha] = this.backgroundColor),
        (s[InAppMessage.ss.va] = this.textColor),
        (s[InAppMessage.ss.wa] = this.closeButtonColor),
        (s[InAppMessage.ss.ya] = this.animateIn),
        (s[InAppMessage.ss.Sa] = this.animateOut),
        (s[InAppMessage.ss.ba] = this.header),
        (s[InAppMessage.ss.ka] = this.headerAlignment),
        (s[InAppMessage.ss.qa] = this.headerTextColor),
        (s[InAppMessage.ss.Aa] = this.frameColor),
        (s[InAppMessage.ss.Ba] = this.buttons),
        (s[InAppMessage.ss.Ca] = this.cropType),
        (s[InAppMessage.ss.Da] = this.orientation),
        (s[InAppMessage.ss.Ea] = this.htmlId),
        (s[InAppMessage.ss.CSS] = this.css),
        (s[InAppMessage.ss.ts] = t),
        (s[InAppMessage.ss.Fa] = this.messageExtras),
        (s[InAppMessage.ss.LANGUAGE] = this.language),
        (s[InAppMessage.ss.ks] = this.altImageText),
        s)
      : s;
  }
}
(InAppMessage.th = {
  hh: 4281545523,
  ih: 4294967295,
  sh: 4278219733,
  Nh: 4293914607,
  Rh: 4283782485,
  Eh: 3224580915,
  eh: 4288387995,
}),
  (InAppMessage.Ao = {
    Sh: "hd",
    Lo: "ias",
    Mh: "of",
    Dh: "do",
    Ch: "umt",
    dh: "tf",
    Uh: "te",
  }),
  (InAppMessage.SlideFrom = { TOP: "TOP", BOTTOM: "BOTTOM" }),
  (InAppMessage.ClickAction = { URI: "URI", NONE: "NONE" }),
  (InAppMessage.DismissType = {
    AUTO_DISMISS: "AUTO_DISMISS",
    MANUAL: "SWIPE",
  }),
  (InAppMessage.OpenTarget = { NONE: "NONE", BLANK: "BLANK" }),
  (InAppMessage.ImageStyle = { TOP: "TOP", GRAPHIC: "GRAPHIC" }),
  (InAppMessage.Orientation = { PORTRAIT: "PORTRAIT", LANDSCAPE: "LANDSCAPE" }),
  (InAppMessage.TextAlignment = {
    START: "START",
    CENTER: "CENTER",
    END: "END",
  }),
  (InAppMessage.CropType = {
    CENTER_CROP: "CENTER_CROP",
    FIT_CENTER: "FIT_CENTER",
  }),
  (InAppMessage.Eo = {
    ia: "SLIDEUP",
    ta: "MODAL",
    Xo: "MODAL_STYLED",
    Yn: "FULL",
    Zo: "WEB_HTML",
    Bo: "HTML",
    Yo: "HTML_FULL",
  }),
  (InAppMessage.hr = 500),
  (InAppMessage.bh = 200),
  (InAppMessage.lh = "ab-show"),
  (InAppMessage.uh = "ab-hide"),
  (InAppMessage.ss = {
    pa: "m",
    ma: "ma",
    _h: "sf",
    xs: "e",
    ua: "ti",
    ca: "ca",
    URI: "u",
    fa: "oa",
    da: "dt",
    la: "d",
    ga: "i",
    ns: "iu",
    ja: "is",
    xa: "ic",
    za: "ibc",
    ha: "bc",
    va: "tc",
    wa: "cbc",
    ya: "ai",
    Sa: "ao",
    ba: "h",
    ka: "ha",
    qa: "htc",
    Aa: "fc",
    Ba: "b",
    Ca: "ct",
    Da: "o",
    Ea: "hi",
    CSS: "css",
    ts: "type",
    ed: "messageFields",
    Fa: "me",
    LANGUAGE: "l",
    ks: "ia",
  });
